/**
 * Libellés FR des droits (Permission côté identity-api), partagés entre le filtrage du
 * menu (ShellComponent) et le message d'accès refusé (permissionGuard) pour rester
 * cohérents sans dupliquer le mapping à deux endroits.
 */
export const PERMISSION_LABELS: Record<string, string> = {
  USERS_READ: 'Utilisateurs',
  USERS_CREATE: 'Utilisateurs',
  USERS_UPDATE: 'Utilisateurs',
  USERS_LOCK: 'Utilisateurs',
  USERS_DELETE: 'Utilisateurs',
  SYSTEM_USERS_MANAGE: 'Comptes système',
  PROPERTIES_READ: 'Biens immobiliers',
  PROPERTIES_VALIDATE: 'Biens immobiliers',
  PROPERTIES_UPDATE: 'Biens immobiliers',
  PROPERTIES_DELETE: 'Biens immobiliers',
  PLANS_READ: 'Plans & Tarifs',
  PLANS_CREATE: 'Plans & Tarifs',
  PLANS_UPDATE: 'Plans & Tarifs',
  PLANS_DELETE: 'Plans & Tarifs',
  DOCUMENTS_READ: "Documents d'inscription",
  DOCUMENTS_VALIDATE: "Documents d'inscription",
  ADS_READ: 'Publicités',
  ADS_MODERATE: 'Publicités',
};

export function permissionLabel(code: string): string {
  return PERMISSION_LABELS[code] ?? code;
}
